import Vue from 'vue'

import HMIcon from './menus/icon'
import HMPlaintext from './menus/plaintext'
import HMStyledPlaintext from './menus/styled-plaintext'
import HMDropdown from './menus/dropdown'
import HMDropdownItem from './menus/dropdown-item'

import HBDropdown from './buttons/dropdown'
import HBAction from './buttons/action'
import HBActionRounded from './buttons/action-rounded'
import HBStatic from './buttons/static'
import HBDropdownSelect from './buttons/dropdown-select'
import HBEmailSelect from './buttons/email-select'
import HBDropdownSearch from './buttons/dropdown-search'
import HBFormConfirm from './buttons/form-confirm'
import HBColorful from './buttons/colorful'

import HCProfile from './cards/profile'
import HCProfileItem from './cards/profile-item'
import HCAction from './cards/action'
import HCTopBanner from './cards/top-banner'
import HCMain from './cards/main'
import HCTopicResume from './cards/topic-resume'
import HCTopicResumeLoader from './cards/topic-resume-loader'
import HCChart from './cards/chart'
import HCCardEmployee from './cards/card'
import HCCompanyCard from './cards/company-card'
import HCCardRounded from './cards/card-rounded'
import HCTask from './cards/task'

import HFAutoFormLite from './form/auto-form-lite'
import HFAutoForm from './form/auto-form'
import HFAutoTable from './form/auto-table'
import HFAutoFilter from './form/auto-filter'
import HFSlider from './form/slider'
import HFStates from './form/states'
import HFFields from './form/fields'
import HFFilter from './form/filter'
import HFGlobalSearchField from './form/global-seach-field'
import HFDesignSearchField from './form/design-search-field'
import HFInputContainer from './form/input-container'
import HFTop from './form/top'
import HFContent from './form/content'
import HFDropzone from './form/dropzone'
import HFFilterWrapper from './form/filter-wrapper'
import HFDateFilter from './form/date-filter'
import HFNumberFilter from './form/number-filter'
import HFDropdown from './form/dropdown'
import HFFieldVisualize from './form/field-visualize'
import HFTiptap from './form/tiptap'
import HFMultiFilter from './form/multi-filter'
import HFModelMultiTaggable from './form/model-multi-taggable'

import HFeNote from './features/note'
import HFeTask from './features/task'
import HFeTaskV2 from './features/task-v2.vue'
import HFeDocument from './features/document'
import HFeTemplateEmail from './features/template-email'
import HFePublicDocument from './features/public-document'
import HFeDashboardLayout from './features/dashboard-layout'
import HFeTreeMenu from './features/tree-menu'
import HFeFileManager from './features/file-manager'
import HFeGantt from './features/gantt'
import HFRedirection from './features/redirection'

import HTTable from './tables/table'
import HTTableElement from './tables/table-element'
import HTTableElementAction from './tables/table-element-action'
import HTTableHeader from './tables/table-header'
import HTTableHeaderAction from './tables/table-header-action'

import HERectangle from './elements/rectangle'
import HEProfileDefault from './elements/profile-default'
import HEMultipleProfileDefault from './elements/multiple-profile-default'
import HEMultipleProfileDefaultV2 from './elements/multiple-profile-default-v2'
import HETitleReturn from './elements/title-return'
import HETopTitle from './elements/top-title'
import HEDefaultInfos from './elements/default-infos'
import HEDefaultInfo from './elements/default-info'
import HESpinner from './elements/spinner'
import HEPaging from './elements/paging'
import HERecap from './elements/recap'
import HECheck from './elements/check'
import HEDeadline from './elements/deadline'
import HELabelTitle from './elements/label-title'
import HEProgressBar from './elements/progress-bar'
import HEDocument from './elements/document'
import HEMail from './elements/mail'
import HEScrollWrapper from './elements/scroll-wrapper'
import HEDetailLoader from './elements/detail-loader'
import HEAvatar from './elements/avatar'
import HEFile from './elements/file'
import HEFolder from './elements/folder'

import HPList from './pipeline/list'
import HPCard from './pipeline/card'
import HPContainer from './pipeline/container'
import HPAddCard from './pipeline/add-card'
import HPRecap from './pipeline/recap'
import HPItemList from './pipeline/item-list'
import HPItemCard from './pipeline/item-card'
import HPLoader from './pipeline/loader'

import HPopUser from './popups/user'
import HPopUserV2 from './popups/user-v2'
import HPopUserVisualizer from './popups/user-visualizer'
import HPopUserVisualizerV2 from './popups/user-visualizer-v2'
import HPopEmailVisualizer from './popups/email-visualizer'
import HPopTemplateEmail from './popups/template-email'
import HPopUserManager from './popups/user-manager'
import HPopAtPopup from './popups/at-popup'

import HWInterview from './widget/interview'
import HWProfile from './widget/profile'
import HWTask from './widget/task'
import HWNotification from './widget/notification'
import HWUpdate from './widget/update'
import HWWeather from './widget/weather'
import HWNote from './widget/note'
import HWRecap from './widget/recap'

import HRInformations from './reporting/informations'
import HRReporting from './reporting/reporting'

Vue.component('h-m-icon', HMIcon)
Vue.component('h-m-plaintext', HMPlaintext)
Vue.component('h-m-styled-plaintext', HMStyledPlaintext)
Vue.component('h-m-dropdown', HMDropdown)
Vue.component('h-m-dropdown-item', HMDropdownItem)

Vue.component('h-b-dropdown', HBDropdown)
Vue.component('h-b-action', HBAction)
Vue.component('h-b-action-rounded', HBActionRounded)
Vue.component('h-b-static', HBStatic)
Vue.component('h-b-dropdown-select', HBDropdownSelect)
Vue.component('h-b-email-select', HBEmailSelect)
Vue.component('h-b-dropdown-search', HBDropdownSearch)
Vue.component('h-b-form-confirm', HBFormConfirm)
Vue.component('h-b-colorful', HBColorful)

Vue.component('h-c-profile', HCProfile)
Vue.component('h-c-profile-item', HCProfileItem)
Vue.component('h-c-action', HCAction)
Vue.component('h-c-top-banner', HCTopBanner)
Vue.component('h-c-main', HCMain)
Vue.component('h-c-topic-resume', HCTopicResume)
Vue.component('h-c-topic-resume-loader', HCTopicResumeLoader)
Vue.component('h-c-chart', HCChart)
Vue.component('h-c-card', HCCardEmployee)
Vue.component('h-c-card-rounded', HCCardRounded)
Vue.component('h-c-company-card', HCCompanyCard)
Vue.component('h-c-task', HCTask)

Vue.component('h-f-auto-table', HFAutoTable)
Vue.component('h-f-auto-filter', HFAutoFilter)
Vue.component('h-f-auto-form', HFAutoForm)
Vue.component('h-f-auto-form-lite', HFAutoFormLite)
Vue.component('h-f-slider', HFSlider)
Vue.component('h-f-states', HFStates)
Vue.component('h-f-fields', HFFields)
Vue.component('h-f-global-search-field', HFGlobalSearchField)
Vue.component('h-f-design-search-field', HFDesignSearchField)
Vue.component('h-f-filter', HFFilter)
Vue.component('h-f-input-container', HFInputContainer)
Vue.component('h-f-top', HFTop)
Vue.component('h-f-content', HFContent)
Vue.component('h-f-dropzone', HFDropzone)
Vue.component('h-f-filter-wrapper', HFFilterWrapper)
Vue.component('h-f-date-filter', HFDateFilter)
Vue.component('h-f-number-filter', HFNumberFilter)
Vue.component('h-f-dropdown', HFDropdown)
Vue.component('h-f-field-visualize', HFFieldVisualize)
Vue.component('h-f-tiptap', HFTiptap)
Vue.component('h-f-multi-filter', HFMultiFilter)
Vue.component('h-f-model-multi-taggable', HFModelMultiTaggable)
Vue.component('h-f-redirection', HFRedirection)

Vue.component('h-fe-note', HFeNote)
Vue.component('h-fe-task', HFeTask)
Vue.component('h-fe-task-v2', HFeTaskV2)
Vue.component('h-fe-document', HFeDocument)
Vue.component('h-fe-template-email', HFeTemplateEmail)
Vue.component('h-fe-public-document', HFePublicDocument)
Vue.component('h-fe-dashboard-layout', HFeDashboardLayout)
Vue.component('h-fe-tree-menu', HFeTreeMenu)
Vue.component('h-fe-gantt', HFeGantt)
Vue.component('h-fe-file-manager', HFeFileManager)

Vue.component('h-t-table', HTTable)
Vue.component('h-t-table-element', HTTableElement)
Vue.component('h-t-table-element-action', HTTableElementAction)
Vue.component('h-t-table-header', HTTableHeader)
Vue.component('h-t-table-header-action', HTTableHeaderAction)

Vue.component('h-e-rectangle', HERectangle)
Vue.component('h-e-profile-default', HEProfileDefault)
Vue.component('h-e-multiple-profile-default', HEMultipleProfileDefault)
Vue.component('h-e-multiple-profile-default-v2', HEMultipleProfileDefaultV2)
Vue.component('h-e-title-return', HETitleReturn)
Vue.component('h-e-top-title', HETopTitle)
Vue.component('h-e-default-infos', HEDefaultInfos)
Vue.component('h-e-default-info', HEDefaultInfo)
Vue.component('h-e-spinner', HESpinner)
Vue.component('h-e-paging', HEPaging)
Vue.component('h-e-recap', HERecap)
Vue.component('h-e-check', HECheck)
Vue.component('h-e-deadline', HEDeadline)
Vue.component('h-e-label-title', HELabelTitle)
Vue.component('h-e-progress-bar', HEProgressBar)
Vue.component('h-e-document', HEDocument)
Vue.component('h-e-mail', HEMail)
Vue.component('h-e-scroll-wrapper', HEScrollWrapper)
Vue.component('h-e-detail-loader', HEDetailLoader)
Vue.component('h-e-avatar', HEAvatar)
Vue.component('h-e-file', HEFile)
Vue.component('h-e-folder', HEFolder)

Vue.component('h-p-list', HPList)
Vue.component('h-p-card', HPCard)
Vue.component('h-p-container', HPContainer)
Vue.component('h-p-add-card', HPAddCard)
Vue.component('h-p-recap', HPRecap)
Vue.component('h-p-item-list', HPItemList)
Vue.component('h-p-item-card', HPItemCard)
Vue.component('h-p-loader', HPLoader)

Vue.component('h-pop-user', HPopUser)
Vue.component('h-pop-user-v2', HPopUserV2)
Vue.component('h-pop-user-visualizer', HPopUserVisualizer)
Vue.component('h-pop-user-visualizer-v2', HPopUserVisualizerV2)
Vue.component('h-pop-email-visualizer', HPopEmailVisualizer)
Vue.component('h-pop-template-email', HPopTemplateEmail)
Vue.component('h-pop-user-manager', HPopUserManager)
Vue.component('h-pop-at-popup', HPopAtPopup)

Vue.component('h-w-interview', HWInterview)
Vue.component('h-w-profile', HWProfile)
Vue.component('h-w-task', HWTask)
Vue.component('h-w-notification', HWNotification)
Vue.component('h-w-update', HWUpdate)
Vue.component('h-w-weather', HWWeather)
Vue.component('h-w-note', HWNote)
Vue.component('h-w-recap', HWRecap)

Vue.component('h-r-informations', HRInformations)
Vue.component('h-r-reporting', HRReporting)
